import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

function isInputEmpty(event: Event): boolean {
  const target = event.target as HTMLElement | null;
  const formField = target?.closest('mat-form-field');
  const input = formField?.querySelector('input, textarea') as HTMLInputElement | HTMLTextAreaElement | null;
  return !input?.value?.trim();
}

export function toggleAutocompletePanel(event: Event, trigger: MatAutocompleteTrigger): void {
  event.stopPropagation();

  if (trigger.panelOpen) {
    trigger.closePanel();
  } else {
    if (isInputEmpty(event)) {
      trigger.autocomplete.options.forEach((option) => option.deselect());
    }
    trigger.openPanel();
  }
}

export function openAutocompletePanel(trigger: MatAutocompleteTrigger): void {
  if (!trigger.panelOpen && !trigger.autocompleteDisabled) {
    trigger.openPanel();
  }
}
